import { useDistricts, useListBus, useProvinces, useTransports } from "hooks";
import { useHubList } from "hooks/hub-management/useHub";
import { useEffect, useMemo, useState } from "react";
import { mapOptionObjectToArray } from "../utils";

const initLocalitiesParams = {
  countryId: 1,
  type: 1,
  parent_code: "",
};

const useHubForm = ({ mainForm, hubId }) => {
  const [provinceParams, setProvinceParams] = useState(initLocalitiesParams);
  const [districtParams, setDistrictParams] = useState(initLocalitiesParams);
  const [wardsParams, setWardsParams] = useState(initLocalitiesParams);

  const [provinceParamsNew, setProvinceParamsNew] =
    useState(initLocalitiesParams);
  const [districtParamsNew, setDistrictParamsNew] =
    useState(initLocalitiesParams);

  const { setValue, getValues, watch } = mainForm;
  const formIsLevel2 = watch("is_level_2");
  const [isLevel2, setIsLevel2] = useState(true);

  const { province_code, district_code, province_code_new } = watch();
  const is_level_2 = formIsLevel2 ?? isLevel2;

  // OLD (3-level) lists (keep behavior)
  const { data: provinces, refetch: refetchProvinces } = useProvinces({
    ...provinceParams,
    record_status: "C",
  });

  useEffect(() => {
    if (provinceParams?.type === 1) {
      refetchProvinces();
    }
  }, [provinceParams.type, refetchProvinces]);

  const provinceOptions = useMemo(() => {
    return mapOptionObjectToArray(provinces);
  }, [provinces]);

  const onChangeProvince = item => {
    setValue("ward_code", null);
    setValue("district_code", null);
    setValue("province_code", item);
  };

  const { data: districts, refetch: refetchDistricts } = useDistricts({
    ...districtParams,
    record_status: "C",
  });

  useEffect(() => {
    if (province_code)
      setDistrictParams(prev => ({
        ...prev,
        type: 2,
        parent_code: province_code.value,
      }));
  }, [province_code]);

  useEffect(() => {
    if (districtParams?.type === 2 && province_code) {
      refetchDistricts();
    }
  }, [districtParams.parent_code]);

  const districtOptions = useMemo(() => {
    return mapOptionObjectToArray(districts);
  }, [districts]);

  const onChangeDistrict = item => {
    setValue("ward_code", null);
    setValue("district_code", item);
    setWardsParams(prev => ({
      ...prev,
      type: 3,
      parent_code: item.value,
    }));
  };

  const isDisableDistrictSelect = useMemo(() => {
    return !Boolean(province_code);
  }, [province_code]);

  const { data: wards, refetch: refetchWards } = useDistricts({
    ...wardsParams,
    record_status: "C",
  });

  useEffect(() => {
    if (district_code)
      setWardsParams(prev => ({
        ...prev,
        type: 3,
        parent_code: district_code.value,
      }));
  }, [district_code]);

  useEffect(() => {
    if (wardsParams?.type === 3 && district_code) {
      refetchWards();
    }
  }, [wardsParams.type, wardsParams.parent_code, refetchWards]);

  const wardOptions = useMemo(() => {
    return mapOptionObjectToArray(wards);
  }, [wards]);

  const onChangeWard = item => {
    setValue("ward_code", item);
  };

  const isDisableWardSelect = useMemo(() => {
    return !Boolean(district_code);
  }, [district_code]);

  const { data: provincesNew, refetch: refetchProvincesNew } = useProvinces({
    ...provinceParamsNew,
    record_status: "O",
  });

  useEffect(() => {
    if (provinceParamsNew?.type === 1) {
      refetchProvincesNew();
    }
  }, [provinceParamsNew.type, refetchProvincesNew]);

  const provinceOptionsNew = useMemo(() => {
    return mapOptionObjectToArray(provincesNew);
  }, [provincesNew]);

  const onChangeProvinceNew = item => {
    setValue("district_code_new", null);
    setValue("province_code_new", item);
  };

  const { data: districtsNew, refetch: refetchDistrictsNew } = useDistricts({
    ...districtParamsNew,
    record_status: "O",
  });

  useEffect(() => {
    if (province_code_new)
      setDistrictParamsNew(prev => ({
        ...prev,
        type: 2,
        parent_code: province_code_new.value,
      }));
  }, [province_code_new]);

  useEffect(() => {
    if (districtParamsNew?.type === 2 && province_code_new) {
      refetchDistrictsNew();
    }
  }, [districtParamsNew.parent_code]);

  const districtOptionsNew = useMemo(() => {
    return mapOptionObjectToArray(districtsNew);
  }, [districtsNew]);

  const onChangeDistrictNew = item => {
    setValue("district_code_new", item);
  };

  const isDisableDistrictSelectNew = useMemo(() => {
    return !Boolean(province_code_new);
  }, [province_code_new]);
  //

  const handleChangeIsLevel2 = value => {
    setIsLevel2(value);
    setValue("is_level_2", value);
    setValue("province_code", null);
    setValue("district_code", null);
    setValue("ward_code", null);
    setValue("parent_hub_id", null);
    setProvinceParams(initLocalitiesParams);
    setDistrictParams(initLocalitiesParams);
    setWardsParams(initLocalitiesParams);
  };

  useEffect(() => {
    setValue("is_level_2", isLevel2);
  }, [isLevel2, setValue]);

  // CENTER SELECT
  const { data: centerList, refetch: refetchHubList } = useHubList({
    params: {
      columnFilter: {
        "filter[is_center]": 1,
        "filter[record_status]": "O",
      },
      fields: "name,id",
    },
  });

  useEffect(() => {
    refetchHubList();
  }, [is_level_2]);

  const centerOptions = useMemo(() => {
    return centerList?.items?.map(item => ({
      value: item.id,
      label: item.name,
    }));
  }, [centerList]);

  const onChangeCenter = item => {
    setValue("parent_hub_id", item);
  };

  const onChangeIsCenter = () => {
    setValue("parent_hub_id", undefined);
    setValue("hub_transport_code", undefined);
  };
  //

  // DVVC
  // const { data: buses, refetch: refetchBusList } = useListBus({
  //   params: {
  //     page: -1,
  //     "per-page": 1000,
  //     fields: "id,name,hub_id",
  //     key: `buses-by-hub-${hubId || "all"}`,
  //     columnFilter: hubId
  //       ? { "filter[hub_id]": hubId, "filter[record_status]": "O" }
  //       : { "filter[record_status]": "O" },
  //   },
  // });
  // const { data: buses, refetch: refetchBusList } = useListBus({
  //   params: {
  //     page: -1,
  //     "per-page": 1000,
  //     fields: "id,name,hub_id",
  //     key: `buses-by-hub-${hubId}`,
  //     columnFilter: {
  //       "filter[hub_id]": hubId,
  //       "filter[record_status]": "O",
  //     },
  //   },
  // });
  // useEffect(() => {
  //   refetchBusList();
  // }, [hubId]);
  const { data: buses, refetch: refetchBusList } = useListBus({
    params: {
      page: -1,
      "per-page": 1000,
      fields: "id,name,is_new_address",
    },
  });
  useEffect(() => {
    refetchBusList();
  }, []);

  const onChangePartnerReceive = item => {
    setValue("ship_partner_receive_sample", item);
    setValue("ship_unit_receive_sample", null);
  };

  const onChangePartnerReturn = item => {
    setValue("ship_partner_return_result", item);
    setValue("ship_unit_return_result", null);
  };

  const busListOptions = useMemo(() => {
    return buses?.items?.map(item => ({
      label: item.name,
      value: item.id,
      is_new_address: item.is_new_address,
    }));
  }, [buses]);

  const { data: transports, refetch: refetchTransports } = useTransports({
    params: {
      page: -1,
      "per-page": 1000,
      fields: "id,name",
    },
  });
  useEffect(() => {
    refetchTransports();
  }, []);
  // const { data: transports, refetch: refetchTransports } = useTransports({
  //   params: {
  //     page: -1,
  //     "per-page": 1000,
  //     fields: "id,name",
  //     key: `transports-by-hub-${hubId || "all"}`,
  //     ...(hubId ? { "filter[hub_id]": hubId } : {}),
  //   },
  // });
  // const { data: transports, refetch: refetchTransports } = useTransports({
  //   params: {
  //     page: -1,
  //     "per-page": 1000,
  //     fields: "id,name",
  //     key: `transports-by-hub-${hubId}`,
  //     "filter[hub_id]": hubId,
  //   },
  // });

  // useEffect(() => {
  //   refetchTransports();
  // }, [hubId]);

  const transportListOptions = useMemo(() => {
    return transports?.items?.map(item => ({
      label: item.name,
      value: item.id,
    }));
  }, [transports]);

  return {
    provinceOptions,
    onChangeProvince,
    districtOptions,
    onChangeDistrict,
    isDisableDistrictSelect,
    wardOptions,
    onChangeWard,
    isDisableWardSelect,

    // NEW
    provinceOptionsNew,
    onChangeProvinceNew,
    districtOptionsNew,
    onChangeDistrictNew,
    isDisableDistrictSelectNew,

    centerOptions,
    onChangeCenter,
    onChangeIsCenter,
    onChangePartnerReceive,
    onChangePartnerReturn,
    busListOptions,
    transportListOptions,
    is_level_2,
    handleChangeIsLevel2,
  };
};

export default useHubForm;
